import { useCallback } from 'react';
import { store } from 'Utilities/store';
import { getConnections as getConnectionsService, getPendingConnections } from 'Services/llu';
const useLegacyConnection = () => {
  const getConnections = useCallback(async () => {
    const {
      user
    } = store.getState().auth;
    const pendingConnections = await getPendingConnections(user.id);
    const caregiverInvitations = pendingConnections.map(connection => {
      return {
        id: connection.id,
        firstName: connection.receiver.firstName,
        lastName: connection.receiver.lastName,
        caregiverId: connection.receiver.accountId,
        email: connection.receiver.email,
        invitationId: connection.id
      };
    });
    const connections = await getConnectionsService();
    const caregiverConnections = connections.map(connection => {
      return {
        id: connection.ConnectionID,
        caregiverId: connection.CaregiverID,
        email: connection.CaregiverEmail,
        firstName: connection.CaregiverFirstName,
        lastName: connection.CaregiverLastName,
        connectedAt: 0
      };
    });
    return {
      caregiverInvitations,
      caregiverConnections
    };
  }, []);
  return {
    getConnections
  };
};
export default useLegacyConnection;